import type { ReceiptMethod } from "@/api/types";

/** How money can arrive from a customer. */
export const RECEIPT_METHODS: ReceiptMethod[] = [
  "Bank transfer",
  "Cheque",
  "Cash",
  "eSewa",
  "ConnectIPS",
];
